export default "__VITE_ASSET__98e72c86__"